import faker from 'faker'
import moment from 'moment'
import hres6aeLabels from 'assets/labels/hres6ae'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres6aeLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 500
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        staappr: '',
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        desc_codcomp: faker.lorem.word(),
        desc_codpos: faker.lorem.word(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number(),
        desc_codleave: faker.lorem.word(),
        dteperiod: moment().format('DD/MM/YYYY') + ' - ' + moment().format('DD/MM/YYYY'),
        status: faker.lorem.word(),
        desc_codappr: faker.name.findName(),
        deslereq: faker.lorem.word(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codinput: faker.finance.mask(),
      desc_codinput: faker.name.findName(),
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      desc_codleave: faker.lorem.word(),
      deslereq: faker.lorem.word(),
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timstrt: faker.date.past().toString().substr(16, 5),
      timend: faker.date.past().toString().substr(16, 5),
      filename: faker.system.commonFileName()
    }
    let mockTab2 = {
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName(),
      typleave: faker.finance.mask(),
      desc_typleave: faker.lorem.word(),
      flgdlemx: faker.random.boolean(),
      day1: faker.random.number().toString().substr(0, 1),
      hur1: faker.random.number().toString().substr(0, 1),
      min1: faker.random.number().toString().substr(0, 1),
      day2: faker.random.number().toString().substr(0, 1),
      hur2: faker.random.number().toString().substr(0, 1),
      min2: faker.random.number().toString().substr(0, 1),
      day3: faker.random.number().toString().substr(0, 1),
      hur3: faker.random.number().toString().substr(0, 1),
      min3: faker.random.number().toString().substr(0, 1),
      day4: faker.random.number().toString().substr(0, 1),
      hur4: faker.random.number().toString().substr(0, 1),
      min4: faker.random.number().toString().substr(0, 1)
    }
    let mockTab3 = {
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName(),
      dtecycst: moment().format('DD/MM/YYYY'),
      dtecycen: moment().format('DD/MM/YYYY')
    }
    let mockTab3Rows = []
    const mockTab3Total = 10
    for (var i = 1; i <= mockTab3Total; i++) {
      mockTab3Rows.push({
        id: i,
        dtework: moment().format('DD/MM/YYYY'),
        codshift: faker.address.stateAbbr(),
        timperiod: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        codleave: faker.lorem.word(),
        desc_codleave: faker.lorem.word(),
        qtymin: faker.random.number().toString().substr(0, 1),
        numlereq: faker.random.number()
      })
    }

    return {
      tab1: mockTab1,
      tab2: mockTab2,
      tab3: {
        detail: mockTab3,
        table: {
          total: mockTab3Total,
          rows: mockTab3Rows
        }
      }
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres63u/mocker.js